import { render, staticRenderFns } from "./occasions.vue?vue&type=template&id=6b9e1d26"
import script from "./occasions.vue?vue&type=script&lang=ts"
export * from "./occasions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiContainer: require('/vercel/path0/components/ui/container.vue').default})
